<div class="offline" *ngIf="isOfflineShown">{{ offline }}</div>
<div class="online" *ngIf="isOnlineShown">{{ online }}</div>



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/offline-indicator/offline-indicator.component.html